import React from 'react'

import TrainerAndSubjectHeader, { sectionHeaderText } from '../../../components/TrainerAndSubjectHeader'
import Container from '../../../components/Container'
import Question from './Question/Question'

const QuestionsPerTrainerAndSubject = (props) => {
  // Nagłówek sekcji („Anna Testowa – Wprowadzenie”) wchodzi do nazwy dostępnej pytań tej sekcji, bo to samo pytanie
  // powtarza się przy każdym prowadzącym. Tylko gdy nagłówek naprawdę jest (pytania ogólne go nie mają).
  const sectionHeaderId = sectionHeaderText(props) ? `${props.sectionId}-naglowek` : undefined

  return (
    <div>
      <TrainerAndSubjectHeader
        id={sectionHeaderId}
        trainer={props.trainer}
        trainerMissing={props.trainerMissing}
        subject={props.subject}
      />
      <Container>
        {
          props.questions.map((question, i, arr) => (
            <Question
              key={question.questionId}
              question={question}
              isNotLastQuestion={i !== arr.length - 1}
              setAnswer={props.setAnswer}
              answers={props.answers}
              missingQuestionIds={props.missingQuestionIds}
              lowMarkHintQuestionIds={props.lowMarkHintQuestionIds}
              savedQuestionUids={props.savedQuestionUids}
              sectionHeaderId={sectionHeaderId}
            />
          ))
        }
      </Container>
    </div>
  )
}

export default QuestionsPerTrainerAndSubject
